export const moonCycle = [
    {
      label: "New Moon",
      value: "new_moon",
    },
    {
      label: "Waxing Crescent",
      value: "waxing_crescent",
    },
    {
        label: "First Quarter",
        value: "first_quarter",
    },
    {
        label: "Waxing Gibbous",
        value: "waxing_gibbous",
    },
    {
        label: "Full Moon",
        value: "full_moon",
    },
    {
        label: "Waning Gibbous",
        value: "waning_gibbous",
    },

    {
        label: "Last Quarter",
        value: "last_quarter",
    },
    {
        label: "Waning Crescent",
        value: "waning_crescent",
    }
  ];
  